export default {"src":"/_next/static/media/withdraw.d71e8b87.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};